import cn from './cn.json';
import en from './en.json';
import jp from './jp.json';
import tw from './tw.json';

/**
 * Novelty Search 多语言文案，与 telecom 模块同构，经 loadI18n mergeLocaleMessage 注入。
 */
export const noveltySearchLocale = {
    cn,
    en,
    jp,
    tw,
};

export function getNoveltySearchLocale(lang: 'cn' | 'en' | 'jp' | 'tw') {
    return noveltySearchLocale[lang] || noveltySearchLocale.en;
}
